"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValueFieldProps = void 0;
const nativeValue_1 = require("./nativeValue");
const valueState_1 = require("./valueState");
const createValueFieldProps = (args) => {
    var _a;
    const { value, config, state, updateValue, formatMessage, name } = args;
    (0, valueState_1.syncStateOnPropsValue)(state, value, config === null || config === void 0 ? void 0 : config.type);
    return {
        value,
        setValue: (newValue) => {
            (0, valueState_1.syncStateOnCallbackValue)(state, newValue, config === null || config === void 0 ? void 0 : config.type);
            updateValue(newValue);
        },
        nativeValue: state.nativeValue,
        setNativeValue: (nativeValue) => {
            // Skip if can't parse
            if (nativeValue === undefined)
                return;
            (0, valueState_1.syncStateOnCallbackNativeValue)(state, nativeValue, config === null || config === void 0 ? void 0 : config.type, formatMessage);
            updateValue(state.callbackValue);
        },
        onChange: (event) => {
            const nativeValue = (0, nativeValue_1.parseNativeEvent)(event, config === null || config === void 0 ? void 0 : config.type);
            // Skip if can't parse
            if (nativeValue === undefined)
                return;
            (0, valueState_1.syncStateOnCallbackNativeValue)(state, nativeValue, config === null || config === void 0 ? void 0 : config.type, formatMessage);
            updateValue(state.callbackValue);
        },
        name,
        error: (config === null || config === void 0 ? void 0 : config.skipValidation) ? undefined : ((_a = state.nativeError) !== null && _a !== void 0 ? _a : state.error),
        required: config ? !config.optional : undefined,
        disabled: config === null || config === void 0 ? void 0 : config.disabled,
        hidden: config === null || config === void 0 ? void 0 : config.hidden,
        modificators: config === null || config === void 0 ? void 0 : config.modificators,
        items: config === null || config === void 0 ? void 0 : config.items,
        query: config === null || config === void 0 ? void 0 : config.query,
        setQuery: config === null || config === void 0 ? void 0 : config.setQuery,
        dateRestrictions: config === null || config === void 0 ? void 0 : config.dateRestrictions,
    };
};
exports.createValueFieldProps = createValueFieldProps;
//# sourceMappingURL=valueFieldProps.js.map